import React from 'react';
import Layout from '../../components/Layout/Layout';
import ViewBooking from './ViewBooking';
import SubNavBar from '../../components/SubNavBar/SubNavBar';

async function action({ params, store, query }) {
    const title = store.getState().siteSettings?.data?.siteTitle
    const description = store.getState().siteSettings?.data?.metaDescription;

    let isAuthenticated = store.getState().runtime.isAuthenticated;

    if (!isAuthenticated) {
        return { redirect: '/' }
    }

    return {
        title,
        description,
        component: (
            <Layout isBottomBanner={true}>
                <div className={isAuthenticated ? "subPageMainContainer" : "withoutPageMainContainer"}>
                    {isAuthenticated && <SubNavBar />}
                    <ViewBooking />
                </div>
            </Layout>
        ),
    };
}

export default action;